// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__1_nFE","tableData":"Table_tableData__38ATk"};